/* eslint-disable jira/filename-case */
// eslint-disable-next-line jira/wrm/no-load-bridge
import { loadBridge } from '@jira/platform__bridge/src';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
type HandlerFunction = (...args: any[]) => void;
type EventType = {
	bind: (eventName: string, handler: HandlerFunction) => void;
	unbind: (eventName: string, handler?: HandlerFunction) => void;
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	trigger: (eventName: string, ...args: any[]) => void;
};

let currentBridge: EventType;

export const apiReady = async (): Promise<EventType> => {
	if (currentBridge) {
		return currentBridge;
	}
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/wrm/no-load-bridge
	const Events = (await loadBridge({
		name: 'jira/util/events',
		wrmKeys: 'wrc!jira.webresources:jira-events',
	})) as EventType;
	currentBridge = Events;
	return Events;
};
